import React from 'react';

const RoleTag = ({ label, offersInfo, color, archivedCount }) => (
  <div className="flex shrink-0 gap-1">
    <span className={`text-${color} bg-${color}-bg py-1 px-2 rounded-3xl`}>{label}</span>
    {offersInfo && <span>{offersInfo}</span>}
    {!!archivedCount && <span className="italic text-flexi-grey">Dont {archivedCount} archivée(s)</span>}
  </div>
);

export default RoleTag;